module.exports = __webpack_public_path__ + "static/media/loginBackgroundSpring.a0afdca5.svg";